import {
    UPDATE_PUSH_API_REPORT_ERROR,
    UPDATE_PUSH_API_REPORT_SUCCESS,
    REQUEST_UPDATE_PUSH_API_SUBSCRIPTION,
} from './actionTypes';

export const requestUpdatePushApiSubscription = () => ({
    type: REQUEST_UPDATE_PUSH_API_SUBSCRIPTION,
});

export const updatePushApiSubscription = report => ({
    type: UPDATE_PUSH_API_REPORT_SUCCESS,
    payload: report,
});

export const updatePushApiSubscriptionError = error => ({
    type: UPDATE_PUSH_API_REPORT_ERROR,
    payload: error,
});
